import React, { useState } from "react";

type UsePaginationReturn = {
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  onTotalPagesChange: (a: any) => void;
  resetPagination: VoidFunction;
};
const DEFAULT_PAGE = 1;

export const usePagination = (): UsePaginationReturn => {
  const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE);

  const onTotalPagesChange = (totalPages: number) => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages || 1);
    }
  };

  const resetPagination = () => setCurrentPage(DEFAULT_PAGE);

  return {
    currentPage,
    setCurrentPage,
    onTotalPagesChange,
    resetPagination
  };
};
